module.exports = __webpack_public_path__ + "assets/devices/MC-302e-72bcd3367d2ae29e166b158326e4a8cd.svg";